<template>
  <div class="form-group">
     <select v-model="selected" class="form-control">
       <option v-for="staffTimeLog in staffTimeLogReadOnlyList" v-bind:key="staffTimeLog.staffTimeLogId" v-bind:value="staffTimeLog.staffTimeLogId">
         {{staffTimeLog.year}}/{{staffTimeLog.month}}
       </option>
     </select>
     <!-- {{selectedX}}
     <v-select v-model="selectedX" label="month" :options="staffTimeLogReadOnlyList"></v-select> -->
     <div>
          <h1>Projekt {{ staffTimeLog.year }}/{{ staffTimeLog.month }}</h1>
            <table class="table table-hover">
              <thead>
                <tr>
                    <th style="width: 20px;">Month, Year</th>
                    <th style="width: 80px;">Norm till tjänstgöringsgrad</th>
                    <th style="width: 80px;">Komp, avvikelse [+/- tim]</th>
                    <th style="width: 80px;">Semester hel/halvdag [1/0,5d]</th>
                    <th style="width: 80px;">VAB [tim]</th>
                    <th style="width: 80px;">Karens [tim]</th>
                    <th style="width: 80px;">Sjukdom [tim]</th>
                    <th style="width: 80px;">Tjänsledig utan lön [tim]</th>
                    <th style="width: 80px;">Tjänsledig med lön [tim]</th>
                    <!-- <th style="width: 80px;">Debiterade insatser [tim]</th>
                    <th style="width: 80px;">Interna insatser [tim]</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="line in staffTimeLog.staffTimeLogLines" track-by="$index" v-bind:key="line.day">
                    <td>
                        {{ line.day }}
                        <input type="hidden" v-model="line.day" number/>
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.standardOfService"/><!-- Norm till tjänstgöringsgrad -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.overtimeHours"/><!-- Komp, avvikelse [+/- tim] -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.sickLeaveHours"/><!--  -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.qualifyingHours"/><!--  -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.childCareHours"/><!--  -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.offDutyHours"/><!--  -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour" v-model="line.vacationDay"/><!--  -->
                    </td>
                    <td>
                        <input :disabled="true" class="input hour text-right" :value="line.overtimeHours * line.sickLeaveHours" number />
                    </td>
                </tr>
              </tbody>
              <!-- <tfoot>
                <tr>
                    <td colspan="5" class="text-right">TAX</td>
                    <td colspan="1" class="text-right">{{ taxtotal | currencyDisplay }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="5" class="text-right">TOTAL</td>
                    <td colspan="1" class="text-right">{{ total | currencyDisplay }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="5" class="text-right">DELIVERY</td>
                    <td colspan="1" class="text-right"><input class="input text-right" v-model="delivery | currencyDisplay" number/></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="5" class="text-right"><strong>GRANDTOTAL</strong></td>
                    <td colspan="1" class="text-right"><strong>{{ grandtotal = total + delivery | currencyDisplay }}</strong></td>
                    <td></td>
                </tr>
              </tfoot> -->
            </table>
        </div>
  </div>
</template>
<style>
</style>

<script>
import { mapState, mapActions } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'staff-time-log-history',
  components: {
    vSelect
  },
  data () {
    return {
      selected: null,
      staffTimeLog: {}
    }
  },
  computed: {
    ...mapState({
      staffTimeLogReadOnlyList: state => state.staffTimeLogs.staffTimeLogReadOnlyList
    })
  },
  watch: {
    'selected': {
      handler () {
        this.getById(this.selected)
          .then(staffTimeLog => {
            this.staffTimeLog = staffTimeLog
          })
      }
    }
  },
  methods: {
    ...mapActions('staffTimeLogs', ['getReadOnlyList', 'getById']),
    init () {
      this.getReadOnlyList()
    }
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/StaffTimeLog/HistoryTab.vue